export default "<app-loading-bar></app-loading-bar>\n\n<router-outlet *ngIf=\"utilisateur\"></router-outlet>"